/* eslint-disable jsx-a11y/anchor-is-valid */

import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, Navigate, useNavigate} from 'react-router-dom'
import {
  ApprovedBussinessName,
  UpdateAssigneTo,
} from '../../../../app/Redux/AdminPanel/AssignUserSlice'
import {readNotification} from '../../../../app/Redux/FrontEnd/NotificationSlice/NotificationSlice'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import './notify.css'
import moment from 'moment-timezone'
import NodataYet from '../../../../app/Components/NodataYet'
import {createFirstLetter} from '../../../../app/Utils/_helpers'

const HeaderNotificationsMenu = () => {
  const navigate = useNavigate()
  const [toggle, setToggle] = useState(false)
  const dispatch = useDispatch()

  const SystemNotifiation = useSelector((state: any) => state?.notification?.system)

  const PortalNotifiation = useSelector((state: any) => state?.notification?.portal)

  const readSystem = (data: any) => {
    let sysData: any[] = [...SystemNotifiation]
    let index = sysData.findIndex((val: any) => val?._id == data.ids[0])
    sysData.splice(index, 1)

    // dispatch(readNotification(sysData))
    dispatch(readNotification({ids: data?.ids}))

    if (data.nav == true) {
      navigate('/topup')
    }
  }

  function stripHtmlTags(input: string): string {
    return input.replace(/<[^>]*>/g, '') // removes all HTML tags
  }

  function formatMessage(message: string): string {
    if (!message) return ''

    const stripped = stripHtmlTags(message)

    const withLinks = stripped.replace(
      /(https?:\/\/[^\s]+)/g,
      (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    )

    // Step 3: Replace newlines with <br> if desired
    return withLinks.replace(/\n/g, '<br />')
  }

  const notificationDot: any = {
    alert: 'dot bg-danger ',
    warn: 'dot bg-warning',
    success: 'dot bg-success',
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div className='d-flex flex-column bgi-no-repeat rounded-top new-gray-bg'>
        <h3 className='text-center fw-bold px-9 mt-10 mb-6'>Notifications</h3>

        <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
          <li className='nav-item'>
            <a
              className={`nav-link text-primary opacity-75 opacity-state-100 pb-4 cursor-pointer ${
                !toggle && 'active'
              }`}
              onClick={() => setToggle(false)}
            >
              Inbox
            </a>
          </li>

          <li className='nav-item'>
            <a
              className={`nav-link text-primary opacity-75 opacity-state-100 pb-4 cursor-pointer ${
                toggle && 'active'
              }`}
              onClick={() => setToggle(true)}
            >
              System
            </a>
          </li>
        </ul>
      </div>

      <div>
        <div className='scroll-y mh-325px notification-list my-5 px-8'>
          {!toggle && PortalNotifiation?.length > 0
            ? PortalNotifiation?.map((val: any, index: number) => (
                <div key={index} className='row align-items-center mb-1'>
                  <div className='col-1'>
                    <span className={notificationDot?.[val?.color]}></span>
                  </div>
                  <div className='col-2 symbol symbol-30px symbol-fixed position-relative'>
                    <span
                      className='circle1'
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    >{`${createFirstLetter(val?.userName)?.firstName ?? 'C'}${
                      createFirstLetter(val?.userName).lastName ?? 'C'
                    }`}</span>
                  </div>
                  <div
                    className='col-5 wrapMessage cursor-pointer px-0'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    title={val?.message}
                  >
                    {val?.notificationType === 'message_verification_request' && (
                      <div
                        onClick={() => {
                          navigate('/accounts/notifications')
                          dispatch(readNotification({ids: [val?._id]}))
                          // window.open(val?.message?.split('URL:')?.[1])
                        }}
                        className='text-truncate'
                      >
                        {val?.message}
                      </div>
                    )}
                    {val?.notificationType !== 'message_verification_request' && (
                      <div
                        onClick={() => {
                          dispatch(readNotification({ids: [val?._id]}))
                          if (val.message.includes('inbox')) {
                            navigate('/inbox')
                          } else {
                            navigate('/accounts/notifications')
                          }
                        }}
                      >
                        <span dangerouslySetInnerHTML={{__html: formatMessage(val?.message)}} />
                      </div>
                    )}
                  </div>
                  <div className='col-4 notify-icons'>
                    <span className='notify_time'>{moment(val?.createdAt).fromNow()}</span>
                  </div>
                </div>
              ))
            : !toggle && <NodataYet message={'No notifications'} />}
          {toggle && SystemNotifiation?.length > 0
            ? SystemNotifiation?.map((val: any, index: number) => (
                <div key={index} className='row align-items-center mb-2'>
                  <div className='col-2'>
                    <span className={notificationDot?.[val?.color]}></span>
                  </div>

                  <div
                    className='col-6 wrapMessage cursor-pointer px-0 text-truncate'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    title={val?.message}
                  >
                    <span
                      onClick={() => {
                        dispatch(readNotification({ids: [val?._id]}))

                        if (val?.notificationType === 'paused_flow') {
                          navigate('/accounts/notifications')
                        } else {
                          navigate('/topup')
                        }
                      }}
                    >
                      {val?.message?.replace(
                        /(https?:\/\/[^\s]+)/g,
                        '<a href="$1" target="_blank">$1</a>'
                      )}
                    </span>
                  </div>
                  <div className='col-4 notify-icons'>
                    {' '}
                    <div className='row justify-content-end'>
                      <span className='notify_time'>{moment(val?.createdAt).fromNow()}</span>
                    </div>
                  </div>
                </div>
              ))
            : toggle && <NodataYet message={'No notifications'} />}
        </div>

        <div className='py-3 text-center border-top'>
          <Link
            to='/accounts/notifications'
            // to='/dashboard'
            onClick={() => {
              const ids = [...SystemNotifiation, ...PortalNotifiation]?.map((key: any) => key?._id)
              dispatch(readNotification({ids: ids}))
            }}
            className='btn btn-color-gray-600 btn-active-color-primary'
          >
            View all
          </Link>
        </div>
      </div>
    </div>
  )
}
export {HeaderNotificationsMenu}
